import { createSlice } from "@reduxjs/toolkit";

export const reviewSharedDataSlice = createSlice({
  name: "reviewSharedData",
  initialState: {
    recipeData: [],
    sdUserData: [],
    availableSdInputStates: [],
    productData: {},
    actionItemData: {},
    lookupOptions: {},
    previousModelRevisions: [],
    previousModelRevisionsSdUserInputs: [],
    comments: [],
    reviewer: {}
  },
  reducers: {
    setSdUserData: (state, action) => {
      const { payload } = action;
      state.sdUserData = payload;
    },
    setRecipeData: (state, action) => {
      const { payload } = action;
      state.recipeData = payload;
    },
    setAvailableSdInputStates: (state, action) => {
      const { payload } = action;
      state.availableSdInputStates = payload;
    },
    setLookupOptions: (state, action) => {
      const { payload } = action;
      state.lookupOptions = payload;
    },
    setProductData: (state, action) => {
      const { payload } = action;
      state.productData = payload;
    },
    setActionItemData: (state, action) => {
      const { payload } = action;
      state.actionItemData = payload;
    },
    setSdModal: (state, action) => {
      const { payload } = action;
      state.sdModal = payload;
    },
    setPreviousModelRevisions: (state, action) => {
      const { payload } = action;
      state.previousModelRevisions = payload;
    },
    setPreviousModelRevisionsSdUserInputs: (state, action) => {
      const { payload } = action;
      let prevSdInputs = [];
      if (Object.keys(payload).length > 0) {
        prevSdInputs = [...state.previousModelRevisionsSdUserInputs, payload];
      }
      state.previousModelRevisionsSdUserInputs = prevSdInputs;
    },
    addComment: (state, action) => {
      const { payload } = action;
      state.comments = [...state.comments, payload];
    },
    deleteComment: (state, action) => {
      const { payload } = action;
      state.comments = state.comments.filter(comment => comment.commentId !== payload.commentId)
    },
    setComments: (state, action) => {
      const { payload } = action;
      state.comments = payload;
    },
    setReviewer: (state, action) => {
      const { payload } = action;
      state.reviewer = payload;
    }
  },
});

export const {
  viewShareData,
  createSharedData,
  updateSharedData,
  deleteSharedData,
  setProductData,
  setSdModal,
  setLookupOptions,
  setComments,
  addComment,
  deleteComment,
  setActionItemData,
  setReviewer
} = reviewSharedDataSlice.actions;

export default reviewSharedDataSlice.reducer;